import React, { useState } from "react";

const RightPanel = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí podrías integrar tu backend o servicio de email
    console.log("Email enviado:", email);
    setSubmitted(true);
    setEmail("");
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "rgba(0,0,0,0.3)", // glass look
        borderRadius: "15px",
        color: "white",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        maxWidth: "250px",
      }}
    >
      <h3 style={{ color: "#00ffff" }}>Stay Updated</h3>
      <p style={{ fontSize: "14px", opacity: 0.8 }}>
        Subscribe to get my portfolio and Web3 project catalog.
      </p>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          style={{
            padding: "10px",
            borderRadius: "10px",
            border: "none",
            outline: "none",
            fontSize: "14px",
          }}
        />
        <button
          type="submit"
          style={{
            background: "#00ffff",
            color: "#000",
            padding: "10px",
            borderRadius: "10px",
            border: "none",
            cursor: "pointer",
          }}
        >
          Subscribe
        </button>
      </form>

      {submitted && (
        <p style={{ fontSize: "14px", color: "#00ffcc", marginTop: "10px" }}>
          Thanks! Check your inbox.
        </p>
      )}

      <div style={{ fontSize: "12px", opacity: 0.6, marginTop: "10px" }}>
        <p>Contact: your@email.com</p>
        <p>Telegram: @youruser</p>
      </div>
    </div>
  );
};

export default RightPanel;